import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ea6b276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tw-document-wrapper z-top controls-background" }
const _hoisted_3 = { class: "card-header bg-white d-flex justify-content-between align-items-center pl-3 pr-2" }
const _hoisted_4 = { class: "card-title mb-0 d-flex align-items-center" }
const _hoisted_5 = { class: "font-weight-bold" }
const _hoisted_6 = { class: "card-title mb-0 d-flex align-items-end" }
const _hoisted_7 = { class: "row card-body tw-document-container scrollable-content" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "font-semi-bold font-size-12" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "p-0 bg-white default-border-radius mb-0" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = { class: "flex-grow-1" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "font-semi-bold font-size-12" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "p-2 bg-white default-border-radius mb-3" }
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = { class: "flex-grow-1" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "text-right" }
const _hoisted_28 = { class: "pt-0" }
const _hoisted_29 = { class: "table-responsive" }
const _hoisted_30 = { class: "table-title" }
const _hoisted_31 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_MessageAlert = _resolveComponent("MessageAlert")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(`${_ctx.$t("printDocument.reference")}: ${_ctx.reference}`), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_q_icon, {
                  name: "chevron_right",
                  size: "20px",
                  onClick: _ctx.toggleShowControls
                }, null, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_q_expansion_item, {
                  "default-opened": "",
                  "switch-toggle-side": "",
                  "header-class": "card-header bg-transparent no-border p-4",
                  class: "tw-items-dashed-group tw-items-group-with-bg tw-level-two-group",
                  onShow: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isExpanded = true)),
                  onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isExpanded = false))
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("alertDialog.sendMail.title")), 1)
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_MessageAlert, { ref: "alertMessage" }, null, 512)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_expansion_item, {
                  "default-opened": "",
                  "switch-toggle-side": "",
                  "header-class": "card-header bg-transparent no-border p-4",
                  class: "tw-items-dashed-group tw-items-group-with-bg tw-level-two-group",
                  onShow: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isExpanded = true)),
                  onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isExpanded = false))
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("alertDialog.alertHistory.title")), 1)
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_q_checkbox, {
                                      key: index,
                                      modelValue: item.selected,
                                      "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                                      label: _ctx.$t('order.alertList.'.concat(item.name))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                  }), 128))
                                ]),
                                _createVNode(_component_q_input, {
                                  type: "textarea",
                                  dense: "",
                                  outlined: "",
                                  label: _ctx.$t('Analysis.Comment'),
                                  class: "w-100 mt-3",
                                  rows: "1",
                                  modelValue: _ctx.comment,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.comment) = $event))
                                }, null, 8, ["label", "modelValue"]),
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_q_checkbox, {
                                    class: "mr-2",
                                    modelValue: _ctx.showDeletedAlerts,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDeletedAlerts) = $event)),
                                    label: _ctx.$t('main.dossier.asset.command.showDeletedAlerts'),
                                    onClick: _ctx.toggleShowDeletedAlerts
                                  }, null, 8, ["modelValue", "label", "onClick"]),
                                  _createVNode(_component_q_btn, {
                                    label: _ctx.$t('main.dossier.asset.command.add'),
                                    class: "btn btn-primary",
                                    disable: _ctx.viewMode || !_ctx.isAnyCheckboxSelected,
                                    onClick: _ctx.onSaveAlert
                                  }, null, 8, ["label", "disable", "onClick"])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("h5", null, _toDisplayString(_ctx.$t("order.alertList.title")), 1)
                                    ]),
                                    _createVNode(_component_q_table, {
                                      class: "shadow-0 table table-sm",
                                      rows: _ctx.rows,
                                      columns: _ctx.columns,
                                      "row-key": "id",
                                      "no-data-label": 
                                                    _ctx.$t('task.historiesStep.headers.histories.noDataMessage')
                                                  
                                    }, {
                                      header: _withCtx((props) => [
                                        _createVNode(_component_q_tr, { props: props }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                                              return (_openBlock(), _createBlock(_component_q_th, {
                                                key: col.name,
                                                props: props
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t(col.label)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["props"]))
                                            }), 128)),
                                            _createVNode(_component_q_th, { "auto-width": "" })
                                          ]),
                                          _: 2
                                        }, 1032, ["props"])
                                      ]),
                                      body: _withCtx((props) => [
                                        _createVNode(_component_q_tr, { props: props }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_td, {
                                              key: "createdBy",
                                              props: props
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(props.row.whoCreated), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["props"]),
                                            _createVNode(_component_q_td, {
                                              key: "creationDate",
                                              props: props
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(props.row.whenCreated), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["props"]),
                                            _createVNode(_component_q_td, {
                                              key: "comment",
                                              props: props
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(props.row.comment), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["props"]),
                                            _createVNode(_component_q_td, {
                                              key: "reasons",
                                              props: props
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.translateReasons(props.row.reasons)), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["props"]),
                                            _createVNode(_component_q_td, { "auto-width": "" }, {
                                              default: _withCtx(() => [
                                                (!_ctx.showDeletedAlerts)
                                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                                      key: 0,
                                                      flat: "",
                                                      round: "",
                                                      icon: "delete",
                                                      color: "red",
                                                      disable: props.row.reasons === 'COMMISSION_MODIFIEE'
                                                          || _ctx.connectedUser.username !== props.row.whoCreated,
                                                      onClick: ($event: any) => (_ctx.deleteAlert(props.row , props.rowIndex))
                                                    }, null, 8, ["disable", "onClick"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["props"])
                                      ]),
                                      _: 1
                                    }, 8, ["rows", "columns", "no-data-label"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createVNode(_component_q_btn, {
                                    class: "btn text-body mr-2",
                                    color: "transparent",
                                    label: _ctx.$t('main.confirmationDialog.cancelButton'),
                                    onClick: _ctx.toggleShowControls
                                  }, null, 8, ["label", "onClick"])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}